import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';

import { PREVENTIVE_TASK_PATH } from '../../../../config/paths';

import {
  clearPreventiveTask,
  getPreventiveTask,
} from '../../../../actions/task-schedule/PreventiveTask';

import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';

import Content from '../../../layout/Content';
import Loader from '../../../common/Loader';
import NoDataResource from '../../../common/resource/NoDataResource';
import InternalResource from '../../../common/resource/InternalResource';

import PreventiveTaskToolbar from './PreventiveTaskToolbar';
import { PREVENTIVE_TASK_WITHOUT_RESOURCE } from '../../../../config/messages';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import PreventiveTaskBasicInformationResource from './resource/PreventiveTaskBasicInformationResource';
import PreventiveTaskChecklistResource from './resource/PreventiveTaskChecklistResource';
import Alert from '../../../common/informative/Alert';
import Table from '../../../common/Table';
import { PREVENTIVE_TASK_RESOURCE_COLUMNS } from '../../../../config/columns';
import { filterMethodCaseInsensitive } from '../../../../utils/filter-methods';

export const PreventiveTask = ({
  breadcrumbs,
  dispatchGetPreventiveTask,
  dispatchClearPreventiveTask,
  match: {
    params: { id: preventiveTaskId },
  },
  loading,
  preventiveTask,
}) => {
  useLayoutEffect(() => {
    dispatchGetPreventiveTask({ preventiveTaskId });

    return () => dispatchClearPreventiveTask();
  }, []);

  let content;
  let toolbar;

  if (loading) content = <Loader />;
  else if (preventiveTask.isEmpty())
    content = <NoDataResource returnPage={PREVENTIVE_TASK_PATH} />;
  else {
    const preventiveTaskJson = preventiveTask.toJS();

    const tableResources =
      preventiveTaskJson.preventiveTaskResourceList !== null &&
      preventiveTaskJson.preventiveTaskResourceList.length !== 0 ? (
        <Table
          columns={PREVENTIVE_TASK_RESOURCE_COLUMNS}
          data={preventiveTaskJson.preventiveTaskResourceList}
          navigateToModelOnRowClick
          filterable
          defaultFilterMethod={filterMethodCaseInsensitive}
          defaultPageSize={
            preventiveTaskJson.preventiveTaskResourceList.length <= 10
              ? preventiveTaskJson.preventiveTaskResourceList.length
              : DEFAULT_PAGE_SIZE
          }
          showPagination={
            preventiveTaskJson.preventiveTaskResourceList.length > 10
          }
          manual={false}
        />
      ) : (
        <Alert message={PREVENTIVE_TASK_WITHOUT_RESOURCE} type="warning" />
      );

    content = (
      <>
        <h3>Información Básica</h3>
        <PreventiveTaskBasicInformationResource {...preventiveTaskJson} />

        <div className="mb-3">
          <h3>Subtareas</h3>
          <PreventiveTaskChecklistResource
            checklistItems={preventiveTaskJson.checklistItems}
          />
        </div>

        <div className="mb-3">
          <h3>Recursos Asociados</h3>
          {tableResources}
        </div>

        <InternalResource
          id={preventiveTaskJson.id}
          createDate={preventiveTaskJson.createDate}
          lastUpdate={preventiveTaskJson.lastUpdate}
        />
      </>
    );

    toolbar = (
      <PreventiveTaskToolbar
        preventiveTaskId={preventiveTaskJson.id}
        preventiveTask={preventiveTaskJson}
      />
    );
  }

  return (
    <Content
      breadcrumbs={breadcrumbs}
      toolbar={toolbar}
      title="Tarea Programada"
      content={content}
    />
  );
};

PreventiveTask.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchClearPreventiveTask: PropTypes.func.isRequired,
  dispatchGetPreventiveTask: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  preventiveTask: PropTypes.instanceOf(Immutable.Map).isRequired,
};

PreventiveTask.defaultProps = {
  loading: false,
};

const mapDispatchToProps = {
  dispatchClearPreventiveTask: clearPreventiveTask,
  dispatchGetPreventiveTask: getPreventiveTask,
};

const mapStateToProps = ({ TaskScheduleUnit }) => ({
  breadcrumbs: [
    ...TaskScheduleUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Tareas Programada',
      href: PREVENTIVE_TASK_PATH,
    },
    {
      text: 'Ver',
      href: '',
    },
  ],
  preventiveTask: TaskScheduleUnit.PreventiveTask.getIn(['current', 'content']),
  loading: !TaskScheduleUnit.PreventiveTask.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

export default connect(mapStateToProps, mapDispatchToProps)(PreventiveTask);
